import { render, staticRenderFns } from "./StaticVanilla.vue?vue&type=template&id=2ec423d4&"
import script from "./StaticVanilla.vue?vue&type=script&lang=js&"
export * from "./StaticVanilla.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports